jQuery(document).ready(function() {
  setTimeout(function() {
    jQuery('#gf-products').addClass('pro_grid_view');
    
    jQuery('.gf_product_view .list_view').click(function() {
      jQuery('#gf-products').removeClass('pro_grid_view').addClass('pro_list_view');
    });
  
    jQuery('.gf_product_view .grid_view').click(function() {
      jQuery('#gf-products').removeClass('pro_list_view').addClass('pro_grid_view');
    });
  }, 2500);
});